import styled from "@emotion/styled";
import { IconButton } from "src/shared/components";
import { IIconButtonProps } from "src/shared/components/buttons/IconButton";

const StyledFilterButton = styled(IconButton)(({ theme }) => ({
  border: `2px solid ${theme.palette.background.default}`,
  width: 22,
  height: 22,
  minWidth: 22,
  padding: 0,
  fontSize: 16,
  ["& svg.icons"]: {
    color: theme.palette.grey[800],
  },
  ["&:hover"]: {
    backgroundColor: theme.palette.grey[300],
  },
  ["&:active"]: {
    backgroundColor: theme.palette.grey[400],
  },
}));

export function FilterButton({
  rounded = true,
  size = "small",
  color = "secondary",
  ...rest
}: IIconButtonProps) {
  return (
    <StyledFilterButton color={color} size={size} rounded={rounded} {...rest} />
  );
}
